module.exports = __webpack_public_path__ + "img/select.3d8d3d6.svg";